import { render, staticRenderFns } from "./getsti.vue?vue&type=template&id=31e6fd74&scoped=true&"
import script from "./getsti.vue?vue&type=script&lang=js&"
export * from "./getsti.vue?vue&type=script&lang=js&"
import style0 from "./getsti.vue?vue&type=style&index=0&id=31e6fd74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e6fd74",
  null
  
)

export default component.exports